export default {
  name: "BlackWhiteDotAnimation",
  components: {},
  props: {
    speed: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      flash: null,
      active: null,
      playing: false
    };
  },
  methods: {
    init() {},
    play(seq) {
      if (this.playing) {
        return;
      }
      this.flash = seq;
      this.playing = true;
      for (let i = 0; i < this.flash.length; i++) {
        setTimeout(() => {
          this.active = this.flash[i];
        }, this.speed * i + 200);
        setTimeout(() => {
          this.active = null;
        }, this.speed * i);
      }
      setTimeout(() => {
        this.active = null;
        this.playing = false;
      }, this.speed * this.flash.length);
    }
  },
  mounted() {
    this.init();
  }
};